import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CustomerGlobalSearchQueryCriteriaClass extends BaseCriteriaModel {
  exts?: Optional<Array<Ext>> = Optional.empty();
  hdr?: Optional<Hdr> = Optional.empty();
}

export class Ext{
  param_code?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  type_of_search?: Optional<number> = Optional.empty();
}

export class Hdr{
  name?: Optional<string> = Optional.empty();
}

export class CustomerGlobalSearchCriteriaModelQuery {
  query = '';

  constructor(customerGlobalSearchCriteriaModel: CustomerGlobalSearchQueryCriteriaClass) {

    if (!customerGlobalSearchCriteriaModel) {
      return;
    }

    // TODO
    // this.query += customerGlobalSearchCriteriaModel.exts.filter(x => x !== '').map(x => '&exts=' + x).orElse('');
    // this.query += customerGlobalSearchCriteriaModel.hdr.filter(x => x !== '').map(x => '&hdr=' + x).orElse('');
    //

    this.query += '&status=' + customerGlobalSearchCriteriaModel.status;
    this.query += '&orderBy=' + customerGlobalSearchCriteriaModel.orderBy;
    this.query += '&order=' + customerGlobalSearchCriteriaModel.order;
    this.query += '&offset=' + customerGlobalSearchCriteriaModel.offset + '&limit=' + customerGlobalSearchCriteriaModel.limit;
  }
}
